module.exports = __webpack_public_path__ + "img/title.11f6db10.png";